
































import Vue from 'vue'
import {reactive, defineComponent} from '@vue/composition-api'
// Note: this requires 'shims-md.d.ts' or Typescript will complain
// about missing module.
import Privacy from '@/components/Docs/Privacy.md'
import Terms from '@/components/Docs/Terms.md'
import Licenses from '@/components/Docs/Licenses.md'
import BetaAgreement from '@/components/Docs/BetaAgreement.md'
import Logo from '@/components/Logo.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// @ts-ignore
import buildInfo from '@/assets/build-info.json'

const components = {Logo, Privacy, Terms, Licenses, BetaAgreement, VuePerfectScrollbar}

export default defineComponent({
  name: 'About',
  components,
  setup() {
    const state = reactive({
      appName: Vue.$appName,
      appVersion: Vue.$appVersion,
      tab: 0,
      tabs: [
        {key: 'tos', title: 'Terms of Service', route: '/about/terms-of-service'},
        {key: 'privacy', title: 'Privacy Policy', route: '/about/privacy-policy'},
        {key: 'licenses', title: 'Credits and Licenses', route: '/about/credits-and-licenses'},
        {key: 'beta', title: 'Beta Test Agreement', route: '/about/beta-agreement'},
      ],
    })
    const appVersionInfo = () => {
      return `v${state.appVersion}, build ${buildInfo.buildId} of ${buildInfo.buildDate}`
    }
    return {state, appVersionInfo}
  }
})
